const normalizeEmail = email => email.trim().toLowerCase()

const getProjectMeta = project => {
  const projectData = project && project.toJS ? project.toJS() : project || {}
  return projectData.Meta || {}
}

const addRecipients = (recipientMap, recipients, confirmed) => {
  if (!Array.isArray(recipients)) return
  recipients.forEach(email => {
    if (typeof email !== 'string') return
    const normalizedEmail = normalizeEmail(email)
    if (!normalizedEmail) return
    const existing = recipientMap.get(normalizedEmail)
    recipientMap.set(normalizedEmail, {
      email: normalizedEmail,
      confirmed: confirmed || Boolean(existing?.confirmed)
    })
  })
}

export const getProjectAlertRecipients = (project, ownEmail) => {
  const projectMeta = getProjectMeta(project)
  const recipientMap = new Map()
  const normalizedOwnEmail = ownEmail ? normalizeEmail(ownEmail) : undefined

  addRecipients(recipientMap, projectMeta.unconfirmedRecipients, false)
  addRecipients(recipientMap, projectMeta.confirmedRecipients, true)

  const recipients = Array.from(recipientMap.values())
  const ownRecipient = recipients.find(recipient => recipient.email === normalizedOwnEmail)

  return {
    ownRecipient,
    recipients: recipients.filter(recipient => recipient.email !== normalizedOwnEmail)
  }
}

export const truncateEmail = email => {
  if (!email) return ''
  return email.length > 21 ? `${email.slice(0, 16)}...` : email
}

export const appendAlertRecipient = (recipients, email) => {
  const normalizedEmail = normalizeEmail(email)
  if (recipients.some(recipient => recipient.email === normalizedEmail)) {
    return recipients
  }

  return [...recipients, { email: normalizedEmail, confirmed: false }]
}
